import { render, staticRenderFns } from "./IconSchool.vue?vue&type=template&id=5cc54b48&"
import script from "./IconSchool.vue?vue&type=script&lang=js&"
export * from "./IconSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports